import axiosInstance from "../config/axiosInstance";
import { API_ENDPOINTS } from "../config/api";

export interface UserPermissionItem {
  userId: number;
  canCreate: boolean;
  canEdit: boolean;
  canDelete: boolean;
}

export const getDeviceGroupList = () =>
  axiosInstance.get(API_ENDPOINTS.getDeviceGroupList);

export const getDeviceGroupListForForm = () =>
  axiosInstance.get(API_ENDPOINTS.getDeviceGroupListForForm);

export const getMyDeviceGroupListForForm = () =>
  axiosInstance.get(API_ENDPOINTS.getMyDeviceGroupListForForm);

export const getDeviceGroupEntity = (id: number) =>
  axiosInstance.get(API_ENDPOINTS.getDeviceGroupEntity(id));

export const createDeviceGroup = (data: { name: string; description?: string }) =>
  axiosInstance.post(API_ENDPOINTS.createDeviceGroup, data);

export const updateDeviceGroup = (data: { id: number; name: string; description?: string }) =>
  axiosInstance.put(API_ENDPOINTS.updateDeviceGroup, data);

export const deleteDeviceGroup = (id: number) =>
  axiosInstance.delete(API_ENDPOINTS.deleteDeviceGroup(id));

export const assignUsersDeviceGroup = (data: { deviceGroupId: number; users: UserPermissionItem[] }) =>
  axiosInstance.put(API_ENDPOINTS.assignUsersDeviceGroup, data);
